export default __webpack_public_path__ + "static/media/waste-wastewater.e7329e63.png";